import { Resolver } from '@wellyes/react-router-extended';
import { HttpService } from '@core/services';
import { ScopingHttpService } from '@core/services/http';
import { BROWSE_DEFAULT_FILTER_VALUE } from '@models/constants';

export class ScopingBrowseResolver implements Resolver {
  async resolve(): Promise<void> {
    await HttpService.getHttpRequests(ScopingHttpService).getScopingBrowse({
      ...BROWSE_DEFAULT_FILTER_VALUE,
      showUnscheduledScopingDateRecords: false,
    });
  }
}
